export default "__VITE_ASSET__ff15aad3__"